









import { Component, Vue } from 'vue-property-decorator';
import { ModalConstants, MapRealmTimeZone } from '@/core/constants';
import { RealmsModule } from '@/store/modules/realms/realms.store';

@Component
export default class NavigationFooter extends Vue {
    get ActiveRealm() {
        return RealmsModule.ActiveRealm;
    }

    SelectRealm() {
        this.$bvModal.show(ModalConstants.SelectRealm);
    }

    mapRealmTimeZone(timeZone) {
        return MapRealmTimeZone(timeZone);
    }
}
